import { Signal } from 'app/design/icons/signal';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Separator } from 'app/design/primitives/text-divider';
import { createTheme as createDSTheme } from 'app/shopify';
import { useTranslation } from 'react-i18next';
import type { NotificationToggle } from './notification-toggle.types';
import { ResponsiveSectionTitle } from './responsive-section-title';
import { ToggleRows } from './toggle-rows';

const theme = createDSTheme();

export const ConciergerieNotificationSection = ({
  isLargeUI,
  toggles,
}: {
  isLargeUI: boolean;
  toggles: NotificationToggle[];
}) => {
  const { t } = useTranslation('notifications-setting');
  return (
    <>
      <Separator onlyWidth />
      <Row alignItems="center" justifyContent={isLargeUI ? 'flex-start' : 'center'} gap="spacing.general.x1">
        <Signal color={theme.colors['text.primary']} width={24} height={24} />
        <ResponsiveSectionTitle {...{ isLargeUI }}>{t('conciergerieTitle')}</ResponsiveSectionTitle>
      </Row>
      <Text variant="bodyBase">{t('conciergerieHelp')}</Text>
      <ToggleRows {...{ toggles }} />
    </>
  );
};
